<template>
  <div>
    <div class="rounded-md w-1/2 bg-white p-5 border">
      <img
        src="https://reportserver.net/g/screenshot/ReportServer-9.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "InformeInventario",
};
</script>

<style>
</style>